<div class="box">
  <p class="subtitle">
    {{ batchUploadMetadata?.batchId }}&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;
    <span class="has-text-weight-light">{{ 'batchMetadata.status.label' | localize }}</span>: <span class="tag is-medium is-light"
                                                             title="{{ 'batchMetadata.status.label' | localize }}">{{ batchUploadMetadata?.status }}</span>
  </p>
  <div class="columns">
    <div class="column is-full content">
      <p class="is-size-6"><strong>{{ 'batchMetadata.batchId.label' | localize }}:</strong> {{ batchUploadMetadata?.batchId }}</p>
      <p class="is-size-6"><strong>{{ 'batchMetadata.filename.label' | localize }}:</strong> {{ batchUploadMetadata?.fileName }}</p>
      @if (batchUploadMetadata?.lastModifiedAt) {
        <p class="is-size-6"><strong>{{ 'batchMetadata.lastModified.label' | localize }}:</strong> {{ batchUploadMetadata?.lastModifiedAt }}</p>
      }
      @if (batchUploadMetadata?.createdAt) {
        <p class="is-size-6"><strong>{{ 'batchMetadata.createdAt.label' | localize }}:</strong> {{ batchUploadMetadata?.createdAt }}</p>
      }
      <p class="is-size-6"><strong>{{ 'batchMetadata.s3Key.label' | localize }}:</strong> <code class="is-size-7">{{ batchUploadMetadata?.s3Key }}</code></p>
      @if (batchUploadMetadata?.importInspection) {
        <h2 class="subtitle is-size-5">{{ 'batchMetadata.importInspection.title' | localize }}</h2>
        <p class="is-size-6"><strong>{{ 'batchMetadata.importInspection.status.label' | localize }}:</strong> {{ batchUploadMetadata?.importInspection?.status }}</p>
        <p class="is-size-6"><strong>{{ 'batchMetadata.importInspection.validatedAt.label' | localize }}:</strong> {{ batchUploadMetadata?.importInspection?.validated_at }}
        </p>

        @if ((batchUploadMetadata?.importInspection?.errors?.length ?? 0) > 0) {
          <p class="is-size-6"><strong>{{ 'batchMetadata.importInspection.errors.label' | localize }}</strong></p>
          <ul>
            @for (error of batchUploadMetadata?.importInspection?.errors ?? []; track error) {
              <li class="is-size-6">{{ error }}</li>
            }
          </ul>
        }

      }
    </div>
  </div>
